import React from "react";
import { useParams } from "react-router-dom";
import { AliasBadgeViewModel, GetBadge, GetBadgeInstance, RedeemBadge } from "../badges/BadgeStore";
import { Anchor, Box, Button, Heading, Image, Text } from "grommet";
import { AliasCard } from "../aliases/AliasCard";
import { format, parseJSON } from "date-fns";
import { useUser } from "../account/AccountStore";

const UXBadgeHome = () => {
    const [badge, setBadge] = React.useState({} as AliasBadgeViewModel);
    const { id } = useParams<{ id: string }>();

    React.useEffect(() => {
        if (id) {
            GetBadgeInstance(id).then((response) => {
                setBadge(response.result);
            });
        }
    }, [id]);

    const [error, setError] = React.useState("");

    const redeemBadge = () => {
        if (id) {
            RedeemBadge(badge.id).then((response) => {
                if (response.success) {
                    GetBadgeInstance(id).then((response) => {
                        setBadge(response.result);
                    });
                } else {
                    setError(response.errors.join("\n"));
                }
            });
        }
    };

    const user = useUser();

    return (
        <>
            {!user.isAuthenticated && (
                <Box align="center" pad="medium">
                    <Text>
                        Please <Anchor href={`/account/signin?redirectUrl=/ue/badges/${id}`}>login here</Anchor> to view this page
                    </Text>
                </Box>
            )}
            {badge.id && (
                <Box align="center">
                    <Image src={badge.badge.logoURI} width="100%" style={{ maxWidth: "200px" }} fit="contain" />
                    <Box gap="xsmall">
                        <Heading level={3}>{badge.badge.name}</Heading>
                        <Text>{badge.badge.description}</Text>
                    </Box>
                    {badge.aliasID && <AliasCard alias={badge.alias}>Redeemed on {format(parseJSON(badge.awardedOn), "yyyy/MM/dd")}</AliasCard>}
                    {!badge.aliasID && <Button label="Redeem this badge" onClick={redeemBadge}></Button>}
                    <Text>{error}</Text>
                </Box>
            )}
        </>
    );
};

export default UXBadgeHome;
